/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Vehicle } from '../../models/vehicle';
import { VehicleCreateRequest } from '../../models/vehicle-create-request';

export interface CreateVehicle$Params {
      body: VehicleCreateRequest
}

export function createVehicle(http: HttpClient, rootUrl: string, params: CreateVehicle$Params, context?: HttpContext): Observable<StrictHttpResponse<Vehicle>> {
  const rb = new RequestBuilder(rootUrl, createVehicle.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Vehicle>;
    })
  );
}

createVehicle.PATH = '/api/v1/vehicles';
